import { Wording } from '@/types';

export const MEDITATION_WORDING_LV: Wording = {
  components_header_media_content: 'Audio',
  components_header_media_1: 'Meditācijas',
  components_header_media_2: 'Podcast',
  components_header_text1: 'Ceļveži',
  components_header_text2: 'Emuārs',
  components_header_members: 'Biedri',
  hero_text: 'Kur meditācija satiekas ar zvaigznēm',
  hero_button_text: 'Sāciet savu ceļojumu uz iekšu',
  components_ressources_section_title: 'RESURSI',
  components_ressources_subheader_text: 'Instrumenti iekšējam mieram, iezemējumam un ikdienas līdzsvaram',
  components_ressources_span_text: 'Atveriet durvis iekšējam mieram, izmantojot mūsu rūpīgi atlasītās meditācijas un ceļvežus. Atrodiet skaidrību, atjaunojiet savienojumu ar elpu un saskaņojieties ar savu iekšējo ritmu — vienu brīdi vienlaikus.',
  components_ressources_card_1_title: 'Atspulgs',
  components_ressources_card_1_text: 'Īsas meditācijas un audio pārdomas, lai centrētu jūsu domas un pielāgotos savam kosmiskajam ritmam.',
  components_ressources_card_2_title: 'Izpētiet dziļumus',
  components_ressources_card_2_text: 'Ceļojiet ārpus virsmas ar ieskaujošiem ceļvežiem, kas apvieno meditāciju, astroloģiju un sevis izpēti, lai radītu ilgstošas ​​pārvērtības.',
  components_ressources_link: 'Skatīt vairāk',
  components_notes_and_google_title_1: 'Dvēselisks norādījums',
  components_notes_and_google_title_2: 'Uzmanīgi rituāli',
  components_notes_and_google_title_3: 'Vadītās meditācijas',
  components_review_google_text: 'Google atsauksmes',
  media_content_section_title: 'AUDIOS',
  media_content_section_subheader_text: 'Mūsu meditācijas',
  text_media_1: '',
  text_media_2: '',
  media_content_section_button_more: 'Atklājiet vairāk',
  text2_section_title: 'BLOGS',
  text2_section_subheader_text: '',
  text2_section_button_more: '',
  components_text1_section_title: 'CEĻVEIDI',
  components_text1_subheader_text: 'Kosmiskās zināšanas ikdienas saskaņošanai',
  components_text1_span_text: 'Saskaņojieties ar Visuma ritmiem: izpētiet padziļinātu astroloģisko un meditatīvo ceļvežu kolekciju, kas izstrādāta, lai modinātu iekšējo skaidrību, padziļinātu pašapziņu un atbalstītu jūsu dvēseles, debesu izaugsmes ceļojumu.',
  components_text1_card_1_title: 'Atvērts klusumam',
  components_text1_card_1_text: 'Sāciet savu ceļojumu ar fundamentāliem meditācijas un astroloģijas ceļvežiem — ideāli piemērots tiem, kurus velk iekšējs klusums, kosmiskie modeļi un personīgais ieskats.',
  components_text1_card_3_title: 'Prāta un ķermeņa saikne',
  components_text1_card_3_text: 'Atklājiet savas iekšējās pasaules dziļākos slāņus. Šie ceļveži virzās ārpus virsmas, lai atklātu nozīmi, emocijas un uzmanīgus modeļus, kas veido jūsu pieredzi.',
  components_text1_card_2_title: 'Atspoguļot un integrēt',
  components_text1_card_2_text: 'No emocionāliem blokiem līdz planētu cikliem — šie ceļveži piedāvā rīkus pārdomām, dziedināšanai un transformācijai, izmantojot apzinātus rituālus un astroloģisko gudrību.',
  components_text1_link: 'Skatīt visus ceļvežus',
  components_footer_text: 'Atmodini sevī: tavs klusums, tavs spēks',
  components_footer_info: 'Informācija',
  components_footer_registration_number: 'Reģistrācijas numurs',
  components_footer_legal: 'Juridisks',
  components_footer_terms: 'Noteikumi un nosacījumi',
  components_footer_privacy: 'Privātuma politika',
  button_load_more: 'Ielādēt vairāk',
  page_media_1_content_hero_text: 'Meditācijas',
  page_media_content_menu_antistress: 'Antistress',
  page_media_content_menu_mindfulness: 'Uzmanība',
  page_media_content_menu_energyboost: 'Enerģijas palielināšana',
  page_media_content_menu_mantra: 'Mantra',
  page_media_2_content_hero_text: '',
  page_text1_hero_text: 'Ceļveži',
  page_text1_section_title: 'Ceļveži',
  page_text1_subheader_text: 'Mūsu ceļveži',
  page_text2_hero_text: '',
  page_text2_section_title: '',
  page_text2_subheader_text: '',
  enter_email_title: 'Lūdzu, ievadiet savu e-pastu, lai turpinātu',
  enter_email_placeholder_email: 'E-pasts',
  enter_email_button_enter: 'Ievadiet',
  components_login_success_text: 'Pieteikšanās veiksmīga!',
  components_card_link_media_content: 'Klausieties tūlīt',
  components_card_link_text1_content: 'Skatīt rokasgrāmatu',
  components_card_link_text2_content: 'Izpētīt',
  france: 'Francija',
  cyprus: 'Kipra',
  tag_podcast: 'Podcast',
  tag_meditation: 'Meditācija',
  page_media_content_menu_all: 'Visi',
};